module.exports = __webpack_public_path__ + "img/derko-logo.99c044dd.png";